import { Suspense } from 'react';
import { useLoaderData, json, defer, Await } from 'react-router-dom';

import EventsList from '../components/EventsList';

function EventsPage() {
  const { events } = useLoaderData();

  return (
    <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
      <Await resolve={events}>
        {(loadedEvents) => <EventsList events={loadedEvents} />}
      </Await>
    </Suspense>
  );
}

export default EventsPage;

async function loadEvents() {
  const response = await fetch('http://localhost:8080/events');

  if (!response.ok) {
    // return { isError: true, message: 'Could not fetch events.' };
    // throw new Response(JSON.stringify({ message: 'Could not fetch events.' }), {
    //   status: 500,
    // });
    throw json(
      { message: 'Could not fetch events.' },
      {
        status: 500,
      }
    );
  } else {
    const resData = await response.json();
    return resData.events;
  }
}

export function loader() {
  return defer({
    events: loadEvents(),
  });
}


// import { Link } from "react-router-dom";

// const Dummy_Events = [
//   {
//     id: 'e1',
//     title: 'Chamber Opening Cermoney',
//   },
//   {
//     id: 'e2',
//     title: 'Guest Gesture cermony',
//   }
// ];

// function EventsPage(){
//     return ( 
//       <>
//         <h1>Events Page</h1>
//         <ul>
//             {Dummy_Events.map(event=><li key={event.id}>
//               <Link to={event.id}>{event.title}</Link>
//             </li>)}
//         </ul>
//       </>
//     );
// }

// export default EventsPage;